<template>
  <form class="db-form" novalidate @submit.prevent="guardar">
    <div class="db-field">
      <label class="db-label" for="fcp-actual">Contraseña actual</label>
      <input
        id="fcp-actual"
        v-model="actual"
        :type="ver ? 'text' : 'password'"
        class="db-input"
        autocomplete="current-password"
        required
      />
    </div>

    <div class="db-form-row">
      <div class="db-field">
        <label class="db-label" for="fcp-nueva">Nueva contraseña</label>
        <div class="db-input-group">
          <input
            id="fcp-nueva"
            v-model="nueva"
            :type="ver ? 'text' : 'password'"
            class="db-input"
            autocomplete="new-password"
            maxlength="128"
            required
          />
          <button
            type="button"
            class="db-icon-btn db-icon-btn--bordered"
            :aria-label="ver ? 'Ocultar contraseñas' : 'Mostrar contraseñas'"
            :title="ver ? 'Ocultar' : 'Mostrar'"
            @click="ver = !ver"
          >
            <span class="material-symbols-outlined">{{ ver ? "visibility_off" : "visibility" }}</span>
          </button>
        </div>
        <requisitos-password :password="nueva" />
      </div>

      <div class="db-field">
        <label class="db-label" for="fcp-repetir">Repite la nueva contraseña</label>
        <input
          id="fcp-repetir"
          v-model="repetir"
          :type="ver ? 'text' : 'password'"
          class="db-input"
          autocomplete="new-password"
          maxlength="128"
          required
        />
        <p v-if="repetir && repetir !== nueva" class="db-hint fcp-error">No coincide con la nueva contraseña.</p>
      </div>
    </div>

    <p v-if="error" class="fcp-error" role="alert">{{ error }}</p>

    <div class="fcp-actions">
      <slot name="extra-actions"></slot>
      <button type="submit" class="db-btn" :disabled="!valido || guardando">
        <span v-if="guardando" class="db-spinner"></span>
        Cambiar contraseña
      </button>
    </div>
  </form>
</template>

<script>
import axios from "@/directives/axios.js";
import { mensajeError, passwordValida } from "@/directives/dbDialogs.js";
import RequisitosPassword from "./RequisitosPassword.vue";

export default {
  name: "FormCambioPassword",

  components: { RequisitosPassword },

  data() {
    return {
      actual: "",
      nueva: "",
      repetir: "",
      ver: false,
      guardando: false,
      error: "",
    };
  },

  computed: {
    valido() {
      return Boolean(this.actual) && passwordValida(this.nueva) && this.nueva === this.repetir;
    },
  },

  watch: {
    actual() {
      this.error = "";
    },
    nueva() {
      this.error = "";
    },
  },

  methods: {
    async guardar() {
      if (!this.valido) return;
      this.guardando = true;
      this.error = "";

      try {
        const response = await axios.put("/perfil/password", {
          current_password: this.actual,
          password: this.nueva,
          password_confirmation: this.repetir,
        });
        this.$store.commit("setUsuario", response.data.usuario);
        this.actual = this.nueva = this.repetir = "";
        this.$emit("cambiada", response.data.usuario);
      } catch (error) {
        this.error = mensajeError(error, "No se pudo cambiar la contraseña.");
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>

<style scoped>
.fcp-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

.fcp-error {
  margin: 0;
  font-size: 0.85rem;
  color: var(--sd-danger, #c62828);
}
</style>
